var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortArrowsBig = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-291 206) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.405,0,18.736,1.669l4.741,4.742H0v2.3H23.477l-4.741,4.534,1.669,1.669,7.453-7.455Z",
    transform: "translate(176 318.858) rotate(-90)",
    fill: "#747676"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.405,0,18.736,1.669l4.741,4.742H0v2.3H23.477l-4.741,4.534,1.669,1.669,7.453-7.455Z",
    transform: "translate(206 293.142) rotate(90)",
    fill: "#747676"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortArrowsBig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sort-arrows-big.3efc454065e42a2bdab460913be7a9c1.svg";